export default class Overlay {
  constructor() {
    this.body = document.querySelector('body');
  }

  open() {
    this.body.classList.add('overlay-active');
  }

  close() {
    this.body.classList.remove('overlay-active');
  }

  element() {
    return document.querySelector('#main-content-overlay');
  }
}
